import { Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState, store } from '../../redux-stores/store';
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants';
import { useCallback, useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { login } from '../../redux-stores/slices/authSlice';
import { fetchInfluencer } from '../../redux-stores/slices/influencerSlice';
import Loader from '../../components/loaders/Loader';

const ifAccountConnected = (WrappedComponent: React.FC): React.FC => {
    return (props: any) => {
        const { isConnected, loading } = useSelector((state: RootState) => state.influencer);
        const igAuthWall = useSelector((state: RootState) => state.auth.configurations?.ig_auth_wall === 'y')
        
        const dispatch = useDispatch<AppDispatch>();
        const navigate = useNavigate();

        const [isLoading, setIsLoading] = useState(false);

        const fetchUser = useCallback(async () => {
            setIsLoading(true);
            const token = store.getState().auth.token ?? '';
            await dispatch(fetchInfluencer(token));
            setIsLoading(false);
            // if (fetchInfluencer.fulfilled.match(result)) {
            //     dispatch(login(token)).finally(() => {
            //         setIsLoading(false)
            //     });
            // }else{
            //     setIsLoading(false);
            // }
        }, [dispatch])

        useIdleTimer({
            onActive: fetchUser,
            timeout: 10 * 10 * 1000, // 10 minutes
            throttle: 2000,
        });

        // useEffect(() => {
        //     fetchUser();
        // }, [fetchUser])

        useEffect(() => {
            if(!isConnected && !loading && !isLoading && igAuthWall){
                navigate(INIT_IG_AUTH_ROUTE, {replace: true})
            }

        }, [isConnected, loading, isLoading])

        if(isLoading) return <Loader isLoading />

        return <WrappedComponent {...props} />;
    };
};

export default ifAccountConnected;